__turbopack_context__.v({
  "Cpart-2": "S6Hkya_Cpart-2",
  "Cpart1": "S6Hkya_Cpart1",
  "Cpart2": "S6Hkya_Cpart2",
  "buttonBoxDestopBtn": "S6Hkya_buttonBoxDestopBtn",
  "buttonBoxMobileBtn": "S6Hkya_buttonBoxMobileBtn",
  "copyRight": "S6Hkya_copyRight",
  "copyRightDiv": "S6Hkya_copyRightDiv",
  "desktopInputHeight": "S6Hkya_desktopInputHeight",
  "footHead": "S6Hkya_footHead",
  "footer": "S6Hkya_footer",
  "footerDiv": "S6Hkya_footerDiv",
  "footerInfo": "S6Hkya_footerInfo",
  "footerParent": "S6Hkya_footerParent",
  "headImage": "S6Hkya_headImage",
  "inlineItem": "S6Hkya_inlineItem",
  "inlineList": "S6Hkya_inlineList",
  "list": "S6Hkya_list",
  "mobileInputHeight": "S6Hkya_mobileInputHeight",
  "part1": "S6Hkya_part1",
  "part2": "S6Hkya_part2",
  "part3": "S6Hkya_part3",
  "siteName": "S6Hkya_siteName",
});
